import * as styles from './index.css';
import { Box, Loader as SeekLoader } from 'braid-design-system';
import type { ComponentProps, FC } from 'react';

interface Props {
  cyName?: string;
  marginY?: ComponentProps<typeof Box>['marginY'];
}

const Loader: FC<Props> = ({
  cyName = 'applications-loader',
  marginY = 'xlarge',
}) => (
  <Box
    data-testid="seek-loader"
    data-cy={cyName}
    className={['applications-loader', styles.loader]}
    marginY={marginY}
    display="flex"
    justifyContent="center"
  >
    <SeekLoader />
  </Box>
);

export default Loader;
